<script setup>
defineProps({
  tabs: { type: Array, required: true },
});

const activeIndex = defineModel({ type: Number, default: 0 });
</script>

<template>
  <div class="flex min-w-0 flex-wrap gap-1 border-b border-n-weak" role="group">
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      type="button"
      class="min-h-11 max-w-full border-b-2 px-3 py-2 text-start text-sm leading-6 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      :class="
        index === activeIndex
          ? 'border-n-brand font-medium text-n-slate-12'
          : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
      "
      :aria-pressed="index === activeIndex"
      @click="activeIndex = index"
    >
      {{ tab.label }}
    </button>
  </div>
</template>
